import { useTracker } from '@coursera/event-pulse/react';

import { MODES } from 'bundles/authentication/shared/components/authentication-modal/AuthenticationContent';
import { useAuthModalTrackerContext } from 'bundles/authentication/shared/components/authentication-modal/contexts/AuthenticationTracking';

const AuthenticationContentTracker = () => {
  const track = useTracker();
  const modalName = useAuthModalTrackerContext()?.modalName;

  if (modalName === MODES.SIGNUP || modalName === MODES.LOGIN) {
    track('view_modal', { modal: { name: modalName } });
  }

  return null;
};

export default AuthenticationContentTracker;
